import dayjs, {Dayjs} from "dayjs";

const moment = require('moment');
class InscripcioFiltre {
    constructor(
        public activitat : number = 0,
        public idCasal : number = 0,
        public idCampus : number = 0,
        public idOpcio : number = 0,
        public setmana : string = "0",
        public dia : string|null|Dayjs = dayjs(),
    ) {}
}

export default InscripcioFiltre;
